export const svgColors = {
  mainColor: "#FF5555",
  textColor: "#0F172A",
  padColor: "#FF5353",
  appleLogo: "#111827",
  starColor: "#F6BE09",
};
